import { Component, OnInit, ViewChild } from '@angular/core'
import { DiscountsTableComponent } from '@tv3/containers/discounts/discounts-table/discounts-table.component'
import { DeleteMultipleLosDiscount } from '@tokeet-frontend/los-discount'
import { ConfirmDialogService } from '@tokeet-frontend/tv3-platform'
import { Store } from '@ngrx/store'
import { DeleteDiscountCodes } from '@tokeet-frontend/discount-codes'
import { ExportDiscountsDialogService } from '@tv3/containers/discounts/dialogs/export/export-discounts-dialog.service'

@Component({
  selector: 'app-discounts',
  templateUrl: './discounts.component.html',
  styleUrls: ['./discounts.component.scss'],
})
export class DiscountsComponent implements OnInit {
  @ViewChild('table') table!: DiscountsTableComponent

  constructor(
    private store: Store<any>,
    private confirmDialog: ConfirmDialogService,
    private exportDiscountsDialog: ExportDiscountsDialogService
  ) {}

  ngOnInit(): void {}

  getDownloadTooltip(download: number) {
    return download > 0
      ? $localize`Download your filtered list to CSV.`
      : $localize`There are no guests under that filter!`
  }

  onDeleteSelected() {
    const items = this.table.selection.selected
    if (!items.length) {
      return
    }
    this.confirmDialog
      .confirm({
        title: $localize`Delete selected discounts?`,
        body: $localize`Are you sure you want to delete the selected discounts?`,
      })
      .subscribe(() => {
        const discountCodeItems = items.filter((i) => i.discountType === 'code')
        const losDiscountItems = items.filter((i) => i.discountType !== 'code')

        if (discountCodeItems.length > 0) {
          const ids = discountCodeItems.map((i) => i.item.id)
          this.store.dispatch(DeleteDiscountCodes({ ids }))
        }

        if (losDiscountItems.length > 0) {
          const ids = losDiscountItems.map((i) => i.item.id)
          this.store.dispatch(DeleteMultipleLosDiscount({ ids }))
        }
      })
  }

  onExport() {
    const selected = this.table?.getSelected()
    const data = selected.length ? selected : this.table?.dataSource.data
    this.exportDiscountsDialog.open(data)
  }
}
